export default __webpack_public_path__ + "static/media/intro2.44709037.png";